import { useCallback, useState } from 'react';

export default () => {
  const [preOrderIds, setPreOrderIds] = useState<any[]>([]); // 分配选择的id
  const [templateId, setTemplateId] = useState<any[]>([]); // 选择的款号
  const [preOrderSum, setPreOrderSum] = useState<any>(); // 预下单列表的数量
  const getPreOrderIds = useCallback(async () => {
    // setState((s) => ({ ...s, loading: true, error: undefined }));
    const preOrderData: any = JSON.parse(sessionStorage.getItem('pre-order-data') || '{}');

    console.log(
      '🚀 7848489494984',
      preOrderData,
      JSON.parse(sessionStorage.getItem('pre-order-data') || '{}'),
    );

    if (preOrderData) {
      setPreOrderIds(preOrderData.ids);
      setTemplateId(preOrderData.template_id);
    }
    return preOrderData;
  }, []);
  const test = useCallback(async () => {
    return preOrderSum;
  }, []);
  return {
    templateId,
    setTemplateId,
    setPreOrderIds,
    preOrderIds,
    getPreOrderIds,
    preOrderSum,
    setPreOrderSum,
    test,
  };
};
